<mat-slide-toggle [(ngModel)]="showApiKey">{{
  translationService.getRevealAPIKeysText()
}}</mat-slide-toggle>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
  <ng-container matColumnDef="apiKey">
    <th mat-header-cell *matHeaderCellDef>
      {{ translationService.getApiKeyText() }}
    </th>
    <td mat-cell *matCellDef="let integration">
      {{ showApiKey ? integration.apiKey : '****' }}
    </td>
  </ng-container>
  <ng-container matColumnDef="client">
    <th mat-header-cell *matHeaderCellDef>
      {{ translationService.getClientText() }}
    </th>
    <td mat-cell *matCellDef="let integration">MIMOSI Connect</td>
  </ng-container>
  <ng-container matColumnDef="expiresAt">
    <th mat-header-cell *matHeaderCellDef>
      {{ translationService.getExpiresAtText() }}
    </th>
    <td mat-cell *matCellDef="let integration">
      {{ integration.expiresAt | date: 'long' }}
    </td>
  </ng-container>
  <ng-container matColumnDef="copy">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let integration">
      <a
        class="dark-link-underline"
        href="javascript:void(0)"
        [cdkCopyToClipboard]="integration.apiKey"
      >
        <mat-icon>content_copy</mat-icon>
      </a>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<mat-paginator
  showFirstLastButtons
  pageSize="10"
  hidePageSize="true"
></mat-paginator>
